import { classNamesFunction } from "@fluentui/react";
import { Stack, IStackTokens } from "@fluentui/react/lib/Stack";
import React, { useState } from "react";
import { HomeProps, HomeStyleProps, HomeStyles } from "./Home.types";
import "./HomeStyle.css";
import { CustomersListing } from "../Quotation/CustomersListing/CustomersListing";
import { EnhancedSearchComponent } from "../../components/EnhancedSearchComponent/EnhancedSearchComponent";

const getClassNames = classNamesFunction<HomeStyleProps, HomeStyles>();

const stackTokens: Partial<IStackTokens> = { childrenGap: 20 };

export const HomeBase: React.FunctionComponent<HomeProps> = (
  props: HomeProps
) => {
  const { styles, theme } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const classNames = getClassNames(styles, {
    theme: theme!,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Stack>
      <Stack
        style={{
          alignItems: "center",
          background: `url('/headerImage.png')`,
          height: "200px",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        tokens={stackTokens}
      >
        <div className="searchbar">
          <h1 style={{ textAlign: "center", color: "white" }}>
            Search quotes or customers
          </h1>
          <Stack style={window.innerWidth>768?{ background: 'yellow', margin: "0px 160px", borderRadius: "2px",}:{ background: 'transparent', borderRadius: "2px", alignItems:'center'}}>
            <EnhancedSearchComponent />
          </Stack>
        </div>
        <br />
        <br />
      </Stack>
      <Stack style={{ paddingLeft: "30px", paddingRight: "30px" , height:"80vh"}}>
        <CustomersListing isLoading={isLoading} setIsLoading={setIsLoading} />
      </Stack>
    </Stack>
  );
};
